<template>
    <select
        class="select"
        :class="{'error-glow': error}"
        :required="required"
        :disabled="readonly"
        :readonly="readonly"
        @change="emitInput">
        <option :value="null" v-if="!required && !value">(Не задано)</option>
        <option
            v-for="option in options"
            :key="option.key"
            :value="option.key"
            :selected="option.key === value"
        >
            {{ option.value }}
        </option>
    </select>
</template>

<script>
import AutoFieldMixin from '../../mixins/AutoField'

export default {
  name: 'vSelect',
  mixins: [AutoFieldMixin],
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      default: ''
    },
    options: {
      type: Array,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
    error: {
        type: Boolean,
        default: false
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isValueTypeValid() {
      return typeof this.value === 'string'
    },
    defaultValue() {
      return null
    }
  },
  methods: {
    valueToSendFromEvent(e) {
      return e.target.value
    }
  },
  created() {
    if (this.required && !this.value && this.options.length > 0) {
      this.$emit('input', this.options[0].key)
    }
  }
}
</script>

<style lang="sass" scoped>
    .select
        border: 1px solid $grey
        outline: none
        background: white
        height: gridSteps(4)
        min-width: gridSteps(20)
        border-radius: 5px
        margin-bottom: gridSteps(2)
        line-height: gridSteps(4)
</style>
